import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import { Redirect, useLocation } from 'react-router-dom';
import { PATH_PAGE, PATH_APP } from 'src/routes/paths';
import LoadingScreen from 'src/components/LoadingScreen';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

AuthProtect.propTypes = {
  children: PropTypes.node,
};

function AuthProtect({ children }) {
  const { isLoading, isAuthenticated } = useAuth();
  const { mfaObligatorio, mfaConfigurado } = useSelector(state => state.authJwt);
  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Redirect to={PATH_PAGE.auth.login} />;
  }

  // Si MFA es obligatorio y el usuario no lo ha configurado,
  // redirigir a la página de cuenta (tab Seguridad MFA), excepto si ya está ahí.
  const isOnAccountPage = location.pathname.startsWith(PATH_APP.management.user.account);
  if (mfaObligatorio && !mfaConfigurado && !isOnAccountPage) {
    return <Redirect to={`${PATH_APP.management.user.account}?tab=mfa`} />;
  }

  return <>{children}</>;
}

export default AuthProtect;
